import React from 'react';
import Icon from '../../../components/AppIcon';

const UpcomingDeadlines = () => {
  const deadlines = [
    {
      id: 1,
      title: 'Press Release Review',
      campaign: 'The Digital Revolution Launch',
      dueDate: '2024-11-02',
      dueTime: '2:00 PM',
      priority: 'high',
      type: 'review',
      assignee: 'Sarah Johnson',
      daysLeft: 2
    },
    {
      id: 2,
      title: 'Email Campaign Send',
      campaign: 'Mystery of the Lost Pages',
      dueDate: '2024-11-05',
      dueTime: '9:00 AM',
      priority: 'high',
      type: 'send',
      assignee: 'Michael Chen',
      daysLeft: 5
    },
    {
      id: 3,
      title: 'Media Kit Finalization',
      campaign: 'Cooking with Heart',
      dueDate: '2024-11-08',
      dueTime: '5:00 PM',
      priority: 'medium',
      type: 'finalize',
      assignee: 'Emma Rodriguez',
      daysLeft: 8
    },
    {
      id: 4,
      title: 'Follow-up Emails',
      campaign: 'Future of AI in Education',
      dueDate: '2024-11-12',
      dueTime: '10:00 AM',
      priority: 'low',
      type: 'followup',
      assignee: 'David Wilson',
      daysLeft: 12
    }
  ];

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'text-error bg-error/10 border-error/20';
      case 'medium': return 'text-warning bg-warning/10 border-warning/20';
      case 'low': return 'text-success bg-success/10 border-success/20';
      default: return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'review': return 'Eye';
      case 'send': return 'Send';
      case 'finalize': return 'CheckCircle';
      case 'followup': return 'RefreshCw';
      default: return 'Clock';
    }
  };

  const getUrgencyIndicator = (daysLeft) => {
    if (daysLeft <= 2) return 'bg-error';
    if (daysLeft <= 5) return 'bg-warning';
    return 'bg-success';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold text-foreground">Upcoming Deadlines</h2>
        <button className="text-sm text-primary hover:text-primary/80 font-medium">
          View Calendar
        </button>
      </div>
      <div className="space-y-4">
        {deadlines?.map((deadline) => (
          <div key={deadline?.id} className={`border rounded-lg p-4 ${getPriorityColor(deadline?.priority)} hover:shadow-sm transition-shadow duration-200`}>
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-start space-x-3">
                <div className="p-2 bg-background rounded-lg">
                  <Icon name={getTypeIcon(deadline?.type)} size={16} className="text-foreground" />
                </div>
                <div>
                  <h3 className="text-sm font-medium text-foreground mb-1">{deadline?.title}</h3>
                  <p className="text-xs text-muted-foreground">{deadline?.campaign}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div className={`w-2 h-2 rounded-full ${getUrgencyIndicator(deadline?.daysLeft)}`} />
                <span className="text-xs font-medium text-foreground">
                  {deadline?.daysLeft} days
                </span>
              </div>
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-1">
                  <Icon name="Calendar" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">
                    {new Date(deadline.dueDate)?.toLocaleDateString('en-US', { 
                      month: 'short', 
                      day: 'numeric' 
                    })}
                  </span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="Clock" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{deadline?.dueTime}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Icon name="User" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">{deadline?.assignee}</span>
                </div>
              </div>
              <button className="text-xs text-primary hover:text-primary/80 font-medium">
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingDeadlines;